import { init, use as registerI18nPlugin } from 'i18next';
import backend from 'i18next-http-backend';
import { useEffect, useState } from 'react';
import { initReactI18next } from 'react-i18next';

const DEFAULT_LANGUAGE = 'en';
const language = (navigator.language || DEFAULT_LANGUAGE).split('-')[0];

// Registered and started at module load, before any component renders — `useTranslation()`
// must see `initReactI18next` already registered on its first-ever call, or its internal hook
// count differs between the pre-init and post-init render and React throws.
registerI18nPlugin(backend);
registerI18nPlugin(initReactI18next);

const initPromise = init({
    lng: language,
    fallbackLng: [DEFAULT_LANGUAGE],
    ns: ['translation'],
    preload: [DEFAULT_LANGUAGE],
    debug: false,
    react: {
        useSuspense: false,
    },
    nsSeparator: false,
    keySeparator: false,
});

const useI18next = () => {
    const [isTranslationsLoaded, setLoadingState] = useState(false);

    useEffect(() => {
        initPromise.then(() => setLoadingState(true));
    }, []);

    return {
        isTranslationsLoaded,
    };
};

export default useI18next;
